























































































































import { Vue, Component, PropSync, Watch, Emit } from 'vue-property-decorator';
import SiteDetails from '@/views/siteManagement/unit/siteDetails.vue';
import BlastingTicketDetails from '@/views/siteManagement/unit/blastingTicketDetails.vue';
import ElectricTicketDetails from '@/views/siteManagement/unit/electricTicketDetails.vue';

import CollapseTransition from '@/components/collapseTransition/collapseTransition'; // 导入过渡函数
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { TableStripe } from '@/mixins/tableStripe';
import { institutionServer, performanceServer, siteManagementServer, userServe } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: { CollapseTransition, PagingUnit, BlastingTicketDetails, SiteDetails, ElectricTicketDetails },
  mixins: [TableStripe],
})
export default class SiteManagement extends Vue {
  showFlag = 1; // 控制显示的组件
  row: any = {}; // 传递一行的值
  /**
   * @todo 后期需要优化的部分
   * @desc 自定义事件，得到要修改一行的数据。
   * @param state - 模板状态 1-开始状态 2-结束状态
   * @returns 返回值描述
   */
  // getRow(row: any) {
  //   this.row = row;
  // }

  @Watch('formData.taskUnitId')
  public watchAreaName(newValue: any, oldValue: any) {
    if (oldValue && newValue && this.areaNameVisible) {
      this.formData.applyStaffId = '';
    }
    if (this.formData.taskUnitId === '') {
      this.formData.applyStaffId = '';
    }
  }

  private areaNameVisible = false;
  // 查询分页表单
  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 0; // 总共多少条数据
  private timeRange: any = [];
  // 表单数据对象
  formData: any = {
    workOrder: '',
    type: '',
    taskUnit: '',
    applyStaffId: '',
    startTime: '',
    endTime: '',
    taskUnitId: '',
    flowStatus: '',
  };
  // table 数据对象
  tableData: any = [];
  options: any = [];

  // 执行部门
  subSpaceByAuthOptions: any = [];
  // 人员
  spaceStaffByAuthOptions: any = [];

  // 任务
  taskOptions: any = [];

  // 作业票类型
  siteOptions: any = [];

  flowStatusOption: any = [];

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    // 获取分页数据
    this.getSiteByAuth();
    this.getSubSpaceByAuth();
    this.getPageData();
    this.getStatusGroup();
  }
  private getStatusGroup() {
    siteManagementServer.getWorkTicketStatusGroup().then((res: any) => {
      if (res.code == 200) {
        this.flowStatusOption = res.data ? res.data : [];
        this.flowStatusOption.push('作废');
      }
    });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc  删除数据
   * @param1 暂无
   * @returns 暂无
   */
  private deleteSiteManagement(id: any) {
    this.$confirm('确认要删除该条数据吗？', '信息', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'box--msg',
    })
      .then(() => {
        siteManagementServer
          .deleteSiteManagementList(id)
          .then((res: any) => {
            this.getPageData(); // 重新渲染表格数据
            this.$message.success('删除成功!');
          })
          .catch((error: any) => {
            this.$message.error('删除失败,请稍后重试!');
          });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除！',
        });
      });
  }

  // 查看
  /**
   * @todo 后期需要优化的部分
   * @desc 点击编辑图标触发，跳转到详情页面。
   * @param1 row: 要展示的这一行的数据对象
   * @returns 暂无
   */
  // @Emit('getRow')
  viewManagement(data?: any) {
    this.row = data;
    if (data.type.indexOf('爆破') !== -1) {
      this.showFlag = 3;
      // this.$emit('update:showFlag', 3); // 跳转到爆破详情页面
    } else if (data.type.indexOf('停电') !== -1 || data.type.indexOf('送电') !== -1) {
      this.showFlag = 4;
      // this.$emit('update:showFlag', 4); // 跳转到停电、送点电详情页面
    } else {
      this.showFlag = 2;
      // this.$emit('update:showFlag', 2); // 跳转到其他详情页面
    }
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getPageData() {
    // 发起接口请求，获取分页数据
    siteManagementServer
      .getSiteManagementList({
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
        search: this.formData.workOrder ? this.formData.workOrder : null,
        type: this.formData.type ? this.formData.type : null,
        startTime: this.timeRange ? (this.timeRange[0] ? this.timeRange[0] : null) : null,
        endTime: this.timeRange ? (this.timeRange[1] ? this.timeRange[1] : null) : null,
        taskUnitId: this.formData.taskUnitId ? this.formData.taskUnitId : null, // 区域,
        // applyStaffId: this.formData.applyStaffId !== '' ? this.formData.applyStaffId.toString() : null,
        applyStaffId: this.formData.applyStaffId ? this.formData.applyStaffId : null,
        flowStatus: this.formData.flowStatus ? this.formData.flowStatus : null,
      })
      .then((res: any) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取部门所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getDeptAndSubDeptList({})
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取作业票所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSiteByAuth() {
    // 发起接口请求，获取分页数据
    performanceServer
      .getSiteAllByAuth({})
      .then((res: any) => {
        this.siteOptions = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取人员数据
   * @param1 暂无
   * @returns 暂无
   */
  getSpaceStaffByAuth(id: any) {
    // 发起接口请求，获取分页数据
    userServe
      .getPageDataAll({ deptId: id })
      .then((res: any) => {
        this.spaceStaffByAuthOptions = res.data;
        this.$forceUpdate();
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 点击分页按钮触发，改变内容
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    // 调用获取分页数据
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  resetFormData() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.formData = {
      workOrder: '',
      type: '',
      taskUnit: '',
      applyStaffId: '',
      startTime: '',
      endTime: '',
      taskUnitId: '',
      flowStatus: '',
    };
    this.timeRange = [];
    this.getPageData();
  }

  // 当申请单位的下拉出现
  private areaNameChange(data: boolean) {
    this.areaNameVisible = data;
  }

  private getAll(e: any) {
    this.formData.applyStaffId = '';
    this.spaceStaffByAuthOptions = [];
    if (e) {
      this.getSpaceStaffByAuth(e);
    }
  }

  chooseCheckStaffIds(data: boolean) {
    if (data && !this.formData.taskUnitId) {
      this.$message.warning('请先选择【申请单位】才会有对应的数据！');
    }
    if (this.formData.taskUnitId && this.spaceStaffByAuthOptions.length === 0) {
      this.$message.warning('此【申请单位】无对应【申请人】的数据！');
    }
  }
}
